import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";

import Swal from "sweetalert2";
import { Router } from '@angular/router';
import * as moment from 'moment';
import { UserMgmtService } from "../../user-management/user-management.service";
import { ExcelService } from "../../dashboard/excel.service";
@Component({
  selector: 'app-monitor-logs',
  templateUrl: './monitor-logs.component.html',
  styleUrls: ['./monitor-logs.component.scss']
})
export class MonitorLogsComponent implements OnInit {
  @ViewChild(DatatableComponent,{ static: false }) table: DatatableComponent;
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  resetPasswordFormSubmitted: boolean = false;
  userId: number;
  statusForm: FormGroup;
  resetPasswordForm: FormGroup;
  subscriptiondata: any;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "In-Active" },
    { id: "suspended", name: "Suspended" },
    { id: "blocked", name: "Blocked" }
  ];
  userlist = [];
  temp = [];
  // userlist = [{ firstname: "Manish", lastName: "Singh", email: "inder@gmail.com ", status: "Active", creationDate: "1565695077" },
  // { firstname: "khurana", lastName: "khurana", email: "khurana@gmail.com ", status: "Blocked", creationDate: "1565695077" }];

  columns = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 100 ;
  offset: number = 0 ;
  rowCount:number = 100 ;
  userSearchType: number = 0;
  startDateEpoch: any;
  endDateEpoch: any;
  startDateObj = { year: null, month: null, day: null };
  endDateObj = { year: null, month: null, day: null };
  startDate: any;
  endDate: any;
  usercount: any;
  downloadList: Array<object> = [];
  paymentHistList:Array<object> = [];
  DateRangeQuery: string = "";
  // paymentHistList=[{
  //   lastPaymentDate:1584448638,
  //   lastSubscriptionAmount:20,
  //   brand:'visa',
  //   last4:'3832'
  // }];
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size:"sm"
  };

  inviteCode:string = '';
  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ExcelService: ExcelService
  ) { }
  ngOnInit() {
    this.getUserList();
    this.getdownloadList();
  }
  reset() {
    this.inviteCode = '';
    this.startDate = null;
    this.endDate = null;
    this.searchText = '';
    this.getUserList();
  
  }

  getUserList() {
    this.spinner.show();
    let query ="offset=0&limit="+this.pageLimit;
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }
    });
  }
  onChangePageLimit(){
    this.getUserList()

  }
  textSearch:string = ''
  applySearch() {


    let startEpoc = new Date(this.startDate).getTime();
    startEpoc = startEpoc / 1000;
    startEpoc = startEpoc
    let endEpoc = new Date(this.endDate).getTime();
    endEpoc = endEpoc / 1000;

    let queryDate = "startDate=" + startEpoc + "&endDate=" + endEpoc;
    let query;



    if (this.userSearchType == 0) {
      query = queryDate;
    } else if (this.userSearchType == 1) {
      query = "&status=suspended?" + queryDate;
    } else if (this.userSearchType == 2) {
      query = "&status=blocked?" + queryDate;
    } else if (this.userSearchType == 3) {
      query = "&status=active?" + queryDate;
    }
   

    this.spinner.show();

    if (this.startDate == undefined) {
      query = "";
    }
    if (this.endDate == undefined) {
      query = "";
    }
    if (this.inviteCode !== '' && this.inviteCode) {
      query = query + '&inviteCode=' +this.inviteCode.trim();
    }
    if (this.textSearch !== '' && this.textSearch) {
      query = query + '&text=' +this.textSearch.trim();
    }
     query= query+"&limit="+this.pageLimit+"&offset="+this.offset;
    this.userMgmtService.SearchUserList(query).subscribe(res => {

      if ((res["message"] == "Success")) {
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount;
        this.spinner.hide();
      } else {

        this.userlist = [];
      }

    });
    this.spinner.hide();
  }
  setPage(pageInfo) {
      this.offset = this.pageLimit * pageInfo.offset;
      this.applySearch();
    
  }
  userSearchTypeChanged() {

    let query = "";
    if (this.userSearchType == 0) {
      query = "";
    } else if (this.userSearchType == 1) {
      query = "status=suspended";
    } else if (this.userSearchType == 2) {
      query = "status=blocked";
    } else if (this.userSearchType == 3) {
      query = "status=active"
    }

    this.spinner.show();
    this.userMgmtService.SearchUserList(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.userlist = res.data.userList;
        this.userlist =  res.data.userList;
        this.temp = res.data.userList;
        this.rowCount=res.data.totalCount || 100;

        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    });
  }


  onStartTimeChange(value: { year: string; month: string; day: string }) {
    let startDateString = value.year + "-" + value.month + "-" + value.day;
    this.startDateEpoch = new Date(startDateString).getTime();
  }

  onEndTimeChange(value: { year: string; month: string; day: string }) {
    let endDateString = value.year + "-" + value.month + "-" + value.day;
    this.endDateEpoch = new Date(endDateString).getTime();
    this.endDateEpoch + 84600000;
  }


  updateUserStatusModal1(row, content, btn) {

    this.userId = row.userId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  paymentHistoryModal(row, content, btn) {

    this.userId = row.userId;
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    this.modalRef = this.modalService.open(content,modelOptions1);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  vitalDetail:any;
  vitalPercentageModal(row, content, btn) {
    this.userId = row.userId;
    this.spinner.show();
    let query = 'userId=' + this.userId;
    this.userMgmtService.getVital(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.vitalDetail = res.data;
        this.spinner.hide();
        this.modalRef = this.modalService.open(content,modelOptions1)
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.userlist = [];
      }

    }, err => {
      this.spinner.hide();
    });
  //  this.getPaymentHistory(this.userId)
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.userDetails = row;
    this.statusFormSubmitted = false;
    let   modelOptions1: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg"
    };
    // this.modalRef = this.modalService.open(content,modelOptions1);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  getPaymentHistory(userId:any) {
    this.userMgmtService.historyPayment(userId).subscribe(res => {
      if ((res["message"] == "Success")) {
        this.paymentHistList = res.data.paymentList;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.paymentHistList = [];
      }
    });
  }
  exportAsXLSX(): void {
    var todayTime = new Date();
    let currentTimeEpoch = Date.now();
    let date = new Date(currentTimeEpoch);
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var year = date.getFullYear();

    this.ExcelService.exportAsExcelFile(this.downloadList,"UserMonitor_"+ month + "/" + day + "/" + year);
  }
  getdownloadList(){
    this.userMgmtService.getUserList().subscribe(res => {
      if ((res["message"] == "Success")) {
     let tempList=res.data.userList;
      tempList.forEach(element => {
        let Obj={ 
          vitalModifyDate: moment.unix(element['vitalModifyDate']).format("MM/DD/YYYY"),
          firstName:element['firstName'] || 'NA',
          lastName:element['lastName'] || 'NA',
          userName:element['userName'] || 'NA',
          mobile:element['mobile'] || 'NA',
          email:element['email'] || 'NA',
        }
        Obj['diastolicPerChangeAverage'] = element["bloodPressure"]['diastolicPerChangeAverage'];
        Obj['diastolicPerChangeLast'] = element["bloodPressure"]['diastolicPerChangeLast'];
        Obj['systolicPerChangeAverage'] = element["bloodPressure"]['systolicPerChangeAverage'];
        Obj['systolicPerChangeLast'] = element["bloodPressure"]['systolicPerChangeLast'];

        
        Obj['bloodSugarPerChangeAverage'] = element["bloodSugar"]['bloodSugarPerChangeAverage'];
        Obj['bloodSugarPerChangeLast'] = element["bloodSugar"]['bloodSugarPerChangeLast'];

        Obj['weightPerChangeAverage'] = element["weight"]['weightPerChangeAverage'];
        Obj['weightPerChangeLast'] = element["weight"]['weightPerChangeLast'];

        Obj['stressPerChangeAverage'] = element["stress"]['stressPerChangeAverage'];
        Obj['stressPerChangeLast'] = element["stress"]['stressPerChangeLast']
      this.downloadList.push(Obj)
      });
      } else {
      }
    });

  }
 
  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function(d) {
      return d.email.toLowerCase().indexOf(val) !== -1 || !val;
    });
    const email = this.temp.filter(function(d) {
      return d.userName.toLowerCase().indexOf(val) !== -1 || !val;

    });

    this.userlist = temp.concat(email);
    this.rowCount= this.userlist.length;
    // update the rows
    // this.userlist = temp;
    this.table.offset = 0;
  
  }



  deleteRecord(record: any) {

    this.spinner.show();

    this.userMgmtService.deleteUser(this.userId).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "User Deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getUserList();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }

  searchTextChanged(event: any) {
    if (event == "") {
      this.getUserList();
    }
  }

  // USER UPDATE STATUS BLOCK
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }


  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatus(test) {
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.spinner.show();
      let finalObj = {
        userId: this.userDetails["userId"],
        status: this.statusForm.controls.newStatus.value
      };

      this.userMgmtService.updateUserStatus(finalObj).subscribe(data => {
        this.spinner.hide();

        if ((data["message"] = "Success")) {
          Swal.fire("Success", "User status updated successfully!", "success");
          this.modalRef.close();
          this.getUserList();
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



}
